import { render } from "./admin-ebook.vue?vue&type=template&id=1b86115e&scoped=true&ts=true"
import script from "./admin-ebook.vue?vue&type=script&lang=ts"
export * from "./admin-ebook.vue?vue&type=script&lang=ts"

import "./admin-ebook.vue?vue&type=style&index=0&id=1b86115e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b86115e"]])

export default __exports__